import { omitItemSku } from '../transformers/omitItemSku'
import { transformers } from '../transformers/transformers'
import { type AnalyticsEvents } from '../types/events'
import { type AnalyticsTransformer } from './Analytics'
import { AnalyticsPlatforms, getAnalyticsPlatforms, getAnalyticsInstance } from './createAnalyticsProviders'
import { GA4 } from './GA4'

export interface ProcessEventArgs {
  event: AnalyticsEvents
  platforms?: AnalyticsPlatforms[]
}
export const processEvent = ({
  event,
  platforms,
}: ProcessEventArgs) => {
  const needProcessPlatforms = platforms ?? getAnalyticsPlatforms()
  needProcessPlatforms.forEach((platform) => {
    const provider = getAnalyticsInstance(platform)
    const transformer = transformers[event.eventName]
      ? (event: AnalyticsEvents) => transformers[event.eventName]?.(platform, event)
      : undefined
    const platformEvent = platform === AnalyticsPlatforms.ALETHEIA ? event : omitItemSku(event)
    // TODO: fix as AnalyticsTransformer
    provider?.processAnalyticsEvent(platformEvent, transformer as AnalyticsTransformer)
  })
}

export interface ProcessPendingEventArgs {
  event: AnalyticsEvents
  platforms?: AnalyticsPlatforms[]
}
export const processPendingEvent = ({
  event,
  platforms,
}: ProcessPendingEventArgs) => {
  const needProcessPlatforms = platforms ?? getAnalyticsPlatforms()
  needProcessPlatforms.forEach((platform) => {
    const provider = getAnalyticsInstance(platform)
    const transformer = transformers[event.eventName]
      ? (event: AnalyticsEvents) => transformers[event.eventName]?.(platform, event)
      : undefined
    if (provider instanceof GA4) {
      // TODO: fix as AnalyticsTransformer
      provider?.sendAnalyticsPendingEvent(event, transformer as AnalyticsTransformer)
    }
  })
}
